import { Component, inject, input, signal, SimpleChanges, TemplateRef, viewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { AdaaHelper } from "../../../../core/utils";
import { Language } from "../../../constants/enums";
import { ContextualHelpContent } from "../../../models/online-help-model";
import { AppService } from "../../../services";
import { PictureComponent } from "../../general";

@Component({
  selector: "adaa-contextual-help-modal",
  imports: [TranslateTokenPipe, PictureComponent],
  templateUrl: "./contextual-help-modal.html",
  styleUrl: "./contextual-help-modal.scss",
})
export class ContextualHelpModalComponent {
  private _modalService = inject(NgbModal);
  private _appService = inject(AppService);
  contents = input.required<ContextualHelpContent[]>();
  currentPageContent = signal<ContextualHelpContent | null>(null);
  currentPage = 0;
  modal = viewChild.required<TemplateRef<unknown>>("content");
  AdaaHelper = AdaaHelper;
  Language = Language;

  public ngOnChanges(changes: SimpleChanges) {
    changes.contents && this.currentPageContent.set(this.contents()[this.currentPage]);
  }

  public open() {
    const modalRef = this._modalService.open(this.modal(), {
      animation: true,
      scrollable: false,
      keyboard: false,
      size: "lg",
      centered: true,
      modalDialogClass: this._appService.language() === Language.Arabic ? "modal-rtl" : "modal-ltr",
    });

    modalRef.dismissed.subscribe(() => this._reset());
    modalRef.closed.subscribe(() => this._reset());
  }

  public changePage(dir: "prev" | "next") {
    if (dir === "prev") {
      this.currentPage = Math.max(this.currentPage - 1, 0);
    } else {
      this.currentPage = Math.min(this.currentPage + 1, this.contents().length - 1);
    }
    this.currentPageContent.set(this.contents()[this.currentPage]);
  }

  private _reset() {
    this.currentPage = 0;
    this.currentPageContent.set(this.contents()[this.currentPage]);
  }
}
